// store
import dataStore from '../../store/data.store';

const authStore = dataStore('auth', {token: null, user: null});

export default authStore;
